import { useEffect, useRef } from "react";
import { useFilterContext } from "../context";

export const useFilterReset = (onReset: () => void) => {
    const { quickFilters } = useFilterContext();
    const prevFiltersRef = useRef(quickFilters);

    useEffect(() => {
        if (JSON.stringify(prevFiltersRef.current) !== JSON.stringify(quickFilters)) {
            onReset();
            prevFiltersRef.current = quickFilters;
        }
    }, [quickFilters, onReset]);
};
